const FOCUS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-plum/25 focus-visible:ring-offset-1";

/**
 * Theme-token selected/idle fill — readable on light and dark host themes.
 * Active: ink on canvas. Inactive: surface with subtle border.
 */
export function selectionClass(active, { disabled = false } = {}) {
  if (disabled) {
    return "opacity-40 cursor-not-allowed bg-surface-muted text-ink border-subtle font-medium";
  }
  return active
    ? "bg-ink text-canvas border-ink font-semibold"
    : "bg-surface text-ink border-subtle font-medium hover:bg-surface-muted active:bg-surface-muted";
}

/**
 * Shared dimensions for product tabs and choice toggles.
 * @param {"default"|"compact"|"checkin"} size
 */
export function tabSizeClass(size = "default") {
  if (size === "compact") {
    return `rounded-btn px-3.5 py-1.5 font-ui text-[14px] border inline-flex items-center gap-2 transition-colors ${FOCUS}`;
  }
  if (size === "checkin") {
    return `rounded-btn px-4 py-2.5 min-h-[48px] w-full font-ui text-[15px] border inline-flex items-center justify-center gap-2 transition-colors ${FOCUS}`;
  }
  return `rounded-btn px-3.5 py-2 min-h-[44px] font-ui text-[14px] border inline-flex items-center gap-2 transition-colors ${FOCUS}`;
}
